import React from 'react'

const campusDiariesHindi = {
  template : 1,
  constants: {
    visibility: 'india',
    BannerDesktopImage: 'https://djhonz7dexnot.cloudfront.net/78eebe492c91c021e3a81d5b6eec2cf307f0e4d7.jpg',
    BannerMobileImage: 'https://djhonz7dexnot.cloudfront.net/6df976bc145b9c96e43413cd5686c4f64779b11f.jpg',
    heading: 'कैंपस डायरीज़ - लेखन प्रतियोगिता',
    subHeading: "लेखको का सम्मान यही हमारी पहचान",
    section_1_Heading: (
      <>
        ये प्रतियोगिता दो भागों में आयोजित की जाएगी  🏁
      </>
    ),
    section_3_Heading: 'उदाहरण के लिए हमारी कुछ Campus Dairies लेखन',
    section_4_Heading: 'उपन्यास लिखने के 5 आसान तरीके',
    earnHeading: <>Earn Upto 10 Lakh <br/> Per Year</>,
    earnSubheading: (
      <>
        After completion of 30K words you can enter into <br />
        Writer’s Benefit Program
      </>
    ),
    section_5_Heading: 'Frequently Asked Questions ⁉️',
    novelContent: 'Read now',
  },
  StageContent: [
    {
      bgColor: '#F8F9FF',
      headingbgColor: '#D7DBF5',
      stageheading: 'stage 1 ',
      stageSubHeading: 'Stage 1 starts from 8th Sep ',
      tableContent: [
        {
          title: 'Last Date to complete 30,000 words',
          img: '⌛',
          date: '3rd Oct',
        },
        {
          title: 'Results on ',
          img: '🎉',
          date: '13th Oct',
        },
      ],
      stageContent: (
        <>
          सभी लेखको को अपनी उपन्यास के 30,000 शब्द दिए गए अवधी से पहले पूरे करने होंगे। तभी आप स्टेज 1 के पात्र होंगे।
          <br />
          1. आपकी उपन्यास हर तरह की शैली में होनी चाहिए, जिसमें रोमान्स, हॉरर, सस्पेन्स, और थ्रिलर जैसी अद्भुत कहानिया हो।
          <br />
          2. आपकी उपन्यास 30,000 शब्द पूरे होने के बाद अगर आपकी कहानी रीडर्स द्वारा सबसे ज्यादा पसंद की जाती है तो वो उपन्यास हमारे Writer Benefit Program के लिए भी चुनी जाएगी।
          <br />
          3. Top 5 लेखक होगें हकदार हमारे इस आकर्षक इनाम के
        </>
      ),
      rank1Prize: '₹5000/-',
      rank2Prize: '₹3000/-',
      rank3Prize: '₹1500/-',
      rank4And5Prize: '₹750/-',
      isLive: true,
    },
    {
      bgColor: '#F8F9FF',
      headingbgColor: '#D7DBF5',
      stageheading: 'Stage 2 ',
      stageSubHeading: 'Contest Starting from 3rd Oct',
      tableContent: [
        {
          title: 'The last date to complete 50,000 words',
          img: '⌛',
          date: '18th Oct',
        },
        {
          title: 'Results on ',
          img: '🎉',
          date: '28th Oct',
        },
      ],
      stageContent: (
        <>
          सभी लेखको को अपनी उपन्यास के 50,000 शब्द दिए गए अवधी से पहले पूरे करने होंगे। तभी आप स्टेज 2 के पात्र होंगे।
          <br />
          1. Top 5 लेखक होगें हकदार हमारे इस आकर्षक इनाम के।
          <br />
          2. विजेताओं को सर्टिफिकेट से सम्मानित किया जाएगा।
          <br />
          3. प्रत्येक लेखक केवल एक पुरस्कार के लिए पात्र है
        </>
      ),
      rank1Prize: '₹10000/-',
      rank2Prize: '₹6000/-',
      rank3Prize: '₹3000/-',
      rank4And5Prize: '₹1500/-',
      isLive: true,
    }
  ],
  exampleNovels: [
    {
      title:
        'Black Love|ब्लैक लव| Author- Riya Pandey',
      novelImgLink:
        'https://djhonz7dexnot.cloudfront.net/00595311fb6cee6e50d6be239457e2c8475c3893.webp',
      novelLink:
        'https://www.pocketnovel.com/novel/000110a34250c774f7d4640adfc73d1a0ed1dbf1',

      novelId: '000110a34250c774f7d4640adfc73d1a0ed1dbf1',
    },
    {
      title:
        'Yakshini l यक्षिणी। Author- Anand Usha Borkar',
      novelImgLink:
        'https://djhonz7dexnot.cloudfront.net/d0fd0dd3ccf00a20e362d2f3ce0d01393fa83e3f.webp',
      novelLink:
        'https://www.pocketnovel.com/novel/9e1d6d8ab592a14b0574103075a5ce95c5bfed43',

      novelId: '9e1d6d8ab592a14b0574103075a5ce95c5bfed43',
    },
    {
      title: 'The Mystery Of My Love | दी मिस्ट्री ऑफ़ माय लव | Author - Sabreen F.s',
      novelImgLink:
        'https://djhonz7dexnot.cloudfront.net/859d36c08c3afd1f3aafe8913e2cfe92116c82ae.jpeg',
      novelLink:
        'https://www.pocketnovel.com/novel/09cd07ebd806431c73ea9832b66b01c102f35d7d',
      novelId: '09cd07ebd806431c73ea9832b66b01c102f35d7d',
    },
    {
      title:
        'Revenge Of The God | रिवेंज ऑफ़ गॉड | Author - R.K',
      novelImgLink:
        'https://djhonz7dexnot.cloudfront.net/a852b41fef39c9e7ea67d546fa483a1803c0feb1.jpeg',
      novelLink:
        'https://www.pocketnovel.com/novel/255e8d1977c5e06c9b18a517c35fb0c0764a6d31',
      novelId: '255e8d1977c5e06c9b18a517c35fb0c0764a6d31',
    },
  ],
  storyPoints: [
    {
      key: 1,
      point:
        'सबसे अहम मुद्दा - उपन्यास के हर chapter के अंत में दिलचस्प सवाल, या कोई इंट्रेस्टिंग डायलॉग, हो जिससे पाठकों की रूचि बनी रहे ।',
    },
    {
      key: 2,
      point:
        'Narration past में हो इस बात का ध्यान रखें! और narration ज़्यादा से ज़्यादा 100 शब्दों का हो ।',
    },
    {
      key: 3,
      point: (
        <>
          डायलाॅग नरेटिव्ह फॉरमॅट में हो, ना की ड्रॅमॅटिक फाॅरमॅट में जैसे की,
          <br />
          a. आर्य- में हुं सृष्टी का संरक्षक, विज्ञान का समिकरण!
          <br />
          b. समय से परे एक ऐसा योद्धा जिसने लोगो पर आने वाली विपत्तियों को दुर किया, ""अर्जुन हे वो! सुपर अर्जुन जो दुष्टो का विनाषक है ! वो ही है आज का सुपर अर्जुन!
        </>
      ),
    },
    {
      key: 4,
      point: (
        <>
          उपन्यास में दो conflict ( संघर्ष ) होने चाहिए
          <br /> a.एक मुख्य संघर्ष - जिसपे आपकी उपन्यास का पूरा a plot निर्भर हो !
          <br /> b.दूसरा उप संघर्ष - जिससे कहानी में रोमांच बरकरार रहे, और आपकी उपन्यास का emotional graph.
          (भावनिक उतार- चढ़ाव) सही तरीके से प्रदर्शित होता रहे ।
        </>
      ),
    },
    {
      key: 5,
      point: 'उपन्यास लिखते वक़्त punctuation का ध्यान रखें ।',
    },
  ],
  FAQs: [
    {
      question: 'When will the awards be given to the author?',
      answer:
        'The awards will be sent within thirty days after the results are announced.',
    }
  ],
}

const campusDiaries = {
  template : 1,
  constants: {
    BannerDesktopImage: 'https://djhonz7dexnot.cloudfront.net/78eebe492c91c021e3a81d5b6eec2cf307f0e4d7.jpg',
    BannerMobileImage: 'https://djhonz7dexnot.cloudfront.net/6df976bc145b9c96e43413cd5686c4f64779b11f.jpg',
    heading: 'Campus Diaries - Novel Writing Competition',
    subHeading: "Be a creator of your own stories",
    section_1_Heading: (
      <>
        The Contest is organized in the following way 🏁
      </>
    ),
    section_3_Heading: 'Sample Novels for Campus Diaries',
    section_4_Heading: 'Writing Tips',
    earnHeading: <>Earn Upto 10 Lakh <br/> Per Year</>,
    earnSubheading: (
      <>
        After completion of 30K words you can enter into <br />
        Writer’s Benefit Program
      </>
    ),
    section_5_Heading: 'Frequently Asked Questions ⁉️',
    novelContent: 'Read now',
  },
  StageContent: [
    {
      bgColor: '#F8F9FF',
      headingbgColor: '#D7DBF5',
      stageheading: 'stage 1 ',
      stageSubHeading: 'Stage 1 starts from',
      tableContent: [
        {
          title: 'Last Date to complete 30,000 words',
          img: '⌛',
          date: '',
        },
        {
          title: 'Results on ',
          img: '🎉',
          date: '',
        },
      ],

      stageContent: (
        <>
          Author need to complete 30,000 words before Last date of stage 1 to be eligible for stage 1 of contest.
          <br />
          1. You can write your novel in any type of genre like Romance, Horror, Suspense, Thriller etc. your book must be fictional
          <br />
          2. After 30,000 words, If your story is most liked by the readers, your novel will also be selected for our Writer Benefit Program.
          <br />
          3. Top 5 selective writers will get amazing prize money for Stage 1
        </>
      ),
      rank1Prize: '₹5000/-',
      rank2Prize: '₹3000/-',
      rank3Prize: '₹1500/-',
      rank4And5Prize: '₹750/-',
      isLive: true,
    },
    {
      bgColor: '#F8F9FF',
      headingbgColor: '#D7DBF5',
      stageheading: 'Stage 2 ',
      stageSubHeading: 'Contest Starting from ',
      tableContent: [
        {
          title: 'The last date to complete 50,000 words',
          img: '⌛',
          date: '',
        },
        {
          title: 'Results on ',
          img: '🎉',
          date: '',
        },
      ],
      stageContent: (
        <>
          Author need to complete overall 50,000 words before Last date of Stage 2 to be eligible for stage 2 of contest.
          <br />
          1. Top 5 selective writers will get amazing prize money for Stage 2
          <br />
          2. The winners will be awarded with certificates.
          <br />
          3. Each writer is only eligible for one prize.
        </>
      ),
      rank1Prize: '₹10000/-',
      rank2Prize: '₹6000/-',
      rank3Prize: '₹3000/-',
      rank4And5Prize: '₹1500/-',
      isLive: true,
    }
  ],
  exampleNovels: [
    {
      title:
        'My Cold Hubby | Author- Neel',
      novelImgLink:
        'https://djhonz7dexnot.cloudfront.net/93acd24d0a637bcc595741f022dd0b5754c3adc8.webp',
      novelLink:
        'https://www.pocketnovel.com/novel/acb49d1f0fec337c557c60c1c8aa1cbce2bf96aa',
      novelId: 'acb49d1f0fec337c557c60c1c8aa1cbce2bf96aa',
    },
    {
      title:
        'The Girl From Paraworld | Author - Stephan',
      novelImgLink:
        'https://djhonz7dexnot.cloudfront.net/ed4084fd6a0d3ba0df39f0987faffed9b2e04c64.jpeg',
      novelLink:
        'https://www.pocketnovel.com/novel/08b8a255fba1c855dc64b71589d9f5dc33c945d7',
      novelId: '08b8a255fba1c855dc64b71589d9f5dc33c945d7',
    },
    {
      title: 'Mask | Author - Sabarni Dutta',
      novelImgLink:
        'https://djhonz7dexnot.cloudfront.net/5e200c18a566478fa4039ba3cea1965e89b168e2.jpeg',
      novelLink:
        'https://www.pocketnovel.com/novel/b1a86f984c8be65519dbeb5118616aa77be47edd',
      novelId: 'b1a86f984c8be65519dbeb5118616aa77be47edd',
    },
    {
      title:
        'Holloway Girl | Author - Stephan',
      novelImgLink:
        'https://djhonz7dexnot.cloudfront.net/7bda971ee6b4fb863e2c6c421a7eef0d4449a011.jpeg',
      novelLink:
        'https://www.pocketnovel.com/novel/1bfb2df9227a5d982b85b11c1df6fc6d19e356ff',
      novelId: '1bfb2df9227a5d982b85b11c1df6fc6d19e356ff',
    },
  ],
  storyPoints: [
    {
      key: 1,
      point:
        'An exciting plot and a story told through minimal characters that have a lot of secrets, hooks, twists and turns, intense plots, a sensitive flow of narration, deep emotional events, and character traits that change over time.',
    },
    {
      key: 2,
      point:
        'Stories with loved tropes and strong emotional arcs do well with our readers.',
    },
    {
      key: 3,
      point: 'Keep us flipping the page by ending each chapter with a small cliffhanger so we have to know what happens next.'
    },
  ],
  FAQs: [
    {
      question: 'When will the awards be given to the author?',
      answer:
        'The awards will be sent within thirty days after the results are announced.',
    }
  ],
}

const campusDiariesTamil = {
  template : 1,
  constants: {
    BannerDesktopImage: 'https://djhonz7dexnot.cloudfront.net/78eebe492c91c021e3a81d5b6eec2cf307f0e4d7.jpg',
    BannerMobileImage: 'https://djhonz7dexnot.cloudfront.net/6df976bc145b9c96e43413cd5686c4f64779b11f.jpg',
    heading: 'கல்லூரி கதைகள் - 2022',
    subHeading: "இனி உலகம் விரும்பும், உங்கள் கதையை.!",
    section_1_Heading: (
      <>
        போட்டியின் விதிமுறைகள் கீழே கொடுக்கப்பட்டுள்ளன 🏁
      </>
    ),
    section_3_Heading: 'Sample Novels for Campus Diaries',
    section_4_Heading: 'Writing Tips',
    earnHeading: <>Earn Upto 10 Lakh <br/> Per Year</>,
    earnSubheading: (
      <>
        After completion of 30K words you can enter into <br />
        Writer’s Benefit Program
      </>
    ),
    section_5_Heading: 'Frequently Asked Questions ⁉️',
    novelContent: 'Read now',
  },
  StageContent: [
    {
      bgColor: '#F8F9FF',
      headingbgColor: '#D7DBF5',
      stageheading: 'stage 1 ',
      stageSubHeading: 'Stage 1 starts from 12th Sep',
      tableContent: [
        {
          title: 'Last Date to complete 30,000 words',
          img: '⌛',
          date: '7th Oct',
        },
        {
          title: 'Results on ',
          img: '🎉',
          date: '17th Oct',
        },
      ],
      stageContent: (
        <>
          முதல் சுற்றின் கடைசி தேதிக்குள் எழுத்தாளர் முப்பதாயிரம் வார்த்தைகளை முடித்திருந்தால் மட்டுமே இந்தப் போட்டிக்குத் தகுதியுடையவராகக் கருதப்படுவார்.
          <br />
          1. ரொமான்ஸ், ஹாரர், சஸ்பென்ஸ், த்ரில்லர் போன்ற ஏதாவது ஒரு வகையை தேர்ந்தெடுத்து உங்கள் நாவலை எழுதலாம். உங்களின் கதை புனைவு கதையாக இருத்தல் அவசியம்.
          <br />
          2. உங்களின் கதை முப்பதாயிரம் வார்த்தைகளை கடந்த பிறகு , பெரும்பாலான வாசகர்களால் உங்களின் கதை விரும்பப்பட்டால் , உங்களின் கதை எங்களது Writer Benefit Program- க்கு தேர்ந்தெடுக்கப்படும்.
          <br />
          3. தேர்ந்தெடுக்கப்பட்ட கதைகளில் முதல் ஐந்து இடத்தை பிடித்து ஸ்டேஜ் ஒன்றில் வெற்றி பெறும் எழுத்தாளர்களுக்கு அட்டகாசமான பரிசுகள் காத்திருக்கின்றன
        </>
      ),
      rank1Prize: '₹5000/-',
      rank2Prize: '₹3000/-',
      rank3Prize: '₹1500/-',
      rank4And5Prize: '₹750/-',
      isLive: true,
    },
    {
      bgColor: '#F8F9FF',
      headingbgColor: '#D7DBF5',
      stageheading: 'Stage 2 ',
      stageSubHeading: 'Contest Starting from 7th Oct',
      tableContent: [
        {
          title: 'The last date to complete 50,000 words',
          img: '⌛',
          date: '22nd Oct',
        },
        {
          title: 'Results on ',
          img: '🎉',
          date: '1st Nov',
        },
      ],
      stageContent: (
        <>
          இரண்டாம் சுற்றின் கடைசி தேதிக்குள் எழுத்தாளர் 50,000 வார்த்தைகளை முடித்திருந்தால் மட்டுமே எழுத்தாளர் இரண்டாம் சுற்றுக்குத் தகுதியுடைவராகக் கருதப்படுவார்.
          <br />
          1. தேர்ந்தெடுக்கப்பட்ட கதைகளில் முதல் ஐந்து இடத்தை பிடித்து இரண்டாம் சுற்றில் வெற்றி பெறும் எழுத்தாளர்களுக்கு அட்டகாசமான பரிசுகள் காத்திருக்கின்றன.
          <br />
          2. வெற்றி பெறும் எழுத்தாளர்களுக்கு சான்றிதழ் வழங்கப்படும்.
          <br />
          3. ஒவ்வொரு எழுத்தாளரும் ஒரு பரிசுக்கு மட்டுமே தகுதியுடையவராவார்.
        </>
      ),
      rank1Prize: '₹10000/-',
      rank2Prize: '₹6000/-',
      rank3Prize: '₹3000/-',
      rank4And5Prize: '₹1500/-',
      isLive: true,
    }
  ],
  exampleNovels: [
    {
      title:
        'வசுந்தரா | Vasundhara | Author - Rebecca',
      novelImgLink:
        'https://djhonz7dexnot.cloudfront.net/c91cebae9836e5292c06136b95f7f0e16af54387.jpeg',
      novelLink:
        'https://www.pocketnovel.com/novel/fb148ed2d4643f6cdac972586f37978f03ee5fcc',
      novelId: 'fb148ed2d4643f6cdac972586f37978f03ee5fcc',
    },
    {
      title:
        'என்னவளே | Ennavale | Author - Gayathri Senthil',
      novelImgLink:
        'https://djhonz7dexnot.cloudfront.net/e58795eb77085f41098162d6d506a3d8c233c8af.jpeg',
      novelLink:
        'https://www.pocketnovel.com/novel/4bdb4afdae88b73ae8e51ef4bcb20417d7bd9e26',
      novelId: '4bdb4afdae88b73ae8e51ef4bcb20417d7bd9e26',
    },
    {
      title: 'லிங்க வேட்டை | Linga vettai | Author - Adithya',
      novelImgLink:
        'https://djhonz7dexnot.cloudfront.net/7d002abe1421294637b5838cb2621f37636212d1.jpeg',
      novelLink:
        'https://www.pocketnovel.com/novel/135b309113830d258eb30e02a0768c3e2b310cc0',
      novelId: '135b309113830d258eb30e02a0768c3e2b310cc0',
    },
    {
      title:
        'என் ஜீவன் நீயே |En Jeevan Neeye | Author- Sarmi',
      novelImgLink:
        'https://djhonz7dexnot.cloudfront.net/7dc3906e0f182597380dabed3cccad3b1bcf4444.jpeg',
      novelLink:
        'https://www.pocketnovel.com/novel/50b72b7b36c4b3e62db5ec93021ae65d91f342ea',
      novelId: '50b72b7b36c4b3e62db5ec93021ae65d91f342ea',
    },
  ],
  storyPoints: [
    {
      key: 1,
      point:
        'பரபரப்பான கதைக்களம் மற்றும் குறைந்தபட்ச கதாபாத்திரங்கள் மூலம் கதையைத் துவங்கலாம். ரகசியங்கள்,  திருப்பங்கள் மற்றும் சுவாரசியமான சம்பவங்கள் மூலம் கதையை நகர்த்தி செல்லலாம்.  தீவிரமான கதைக்களம், உணர்ச்சிகரமான கதை ஓட்டம், ஆழமான உணர்ச்சிகரமான நிகழ்வுகள் மற்றும் காலப்போக்கில் மாறும் கதாபாத்திரங்கள் மூலம் கதையை மேலும் சுவாரசியமாக்கலாம்.',
    },
    {
      key: 2,
      point:
        'அழுத்தமான காதல் கதைகள் மற்றும் உணர்ச்சிகரமான கதைக்களம் கொண்ட கதைகளை எங்களின் வாசகர்கள் பெரிதும் விரும்புகின்றனர்.',
    },
    {
      key: 3,
      point: 'ஒவ்வொரு அத்தியாயத்தின் முடிவிலும் அடுத்த அத்தியாத்தில் நடக்க போகும் சுவாரசியமான சம்பவம் பற்றி சிறிதளவு வெளிப்படுத்தும் போது அது வாசகர்களை அடுத்த அத்தியாயத்தை படிக்க தூண்டும்.'
    },
  ],
  FAQs: [
    {
      question: 'When will the awards be given to the author?',
      answer:
        'The awards will be sent within thirty days after the results are announced.',
    }
  ],
}

const campusDiariesUniversalHindi = {
  template : 2,
  constants: {
    visibility: 'india',
    BannerDesktopImage: 'https://djhonz7dexnot.cloudfront.net/78eebe492c91c021e3a81d5b6eec2cf307f0e4d7.jpg',
    BannerMobileImage: 'https://djhonz7dexnot.cloudfront.net/6df976bc145b9c96e43413cd5686c4f64779b11f.jpg',
    heading: 'कैंपस डायरीज़ - लेखन प्रतियोगिता',
    subHeading: "लेखको का सम्मान यही हमारी पहचान",
    section_1_Heading: (
      <>
        Pocket Novel आपके लिए एक बार फिर ले कर आया है लेखन प्रतियोगिता।
      </>
    ),
    section_3_Heading: 'उदाहरण के लिए हमारी कुछ Campus Dairies लेखन',
    section_4_Heading: 'उपन्यास लिखने के 5 आसान तरीके',
    earnHeading: <>Earn Upto 10 Lakh <br/> Per Year</>,
    earnSubheading: (
      <>
        After completion of 30K words you can enter into <br />
        Writer’s Benefit Program
      </>
    ),
    section_5_Heading: 'Frequently Asked Questions ⁉️',
    novelContent: 'Read now',
  },
  StageContent: [
    {
      bgColor: '#F8F9FF',
      headingbgColor: '#D7DBF5',
      stageheading: 'Intstructions',
      stageSubHeading: '',
      tableContent: [
        {
          title: 'No of words [ शब्द मर्यादा ]',
          img: '📄',
          date: '30,000 Words',
        },
        {
          title: 'No of days [ शब्द पुर्ण करने की अवधी ]',
          img: '⌛',
          date: 'Within 25 days',
        },
        {
          title: 'Result declaration [ प्रतियोगिता परिणाम ] ',
          img: '🥳',
          date: '15 days after competition ends',
        },
      ],
      stageContent: (
        <>
          Competition Rules
          <br />
          1. आपकी उपन्यास हर तरह की शैली में होनी चाहिए, जिसमें रोमान्स, हॉरर, सस्पेन्स, और थ्रिलर जैसी अद्भुत कहानिया हो।
          <br />
          2. आपकी उपन्यास 30,000 शब्द पूरे होने के बाद अगर आपकी कहानी रीडर्स द्वारा सबसे ज्यादा पसंद की जाती है तो वो उपन्यास हमारे Writer Benefit Program के लिए भी चुनी जाएगी।
          <br />
          3. प्रतियोगिता के पुर्ण होने पश्चात 15 दिनों के अंदर प्रतियोगिता के परिणाम घोषित किए जाऐंगें |
          <br />
          4. Top 5 लेखक होगें हकदार हमारे इस आकर्षक इनाम के
          <br />
          5. विजेताओं को सर्टिफिकेट से सम्मानित किया जाएगा। 
        </>
      ),
      rank1Prize: '₹10000/-',
      rank2Prize: '₹5000/-',
      rank3Prize: '₹2000/-',
      rank4And5Prize: '₹1000/- each',
      isLive: true,
    }
  ],
  exampleNovels: [
    {
      title:
        'Mann Ke Mitwa| मन के मितवा| Author- Sandhya Sarate',
      novelImgLink:
        'http://djhonz7dexnot.cloudfront.net/a8a52a4525259b4b3bf124932402823236b113db.webp',
      novelLink:
        'https://www.pocketnovel.com/novel/5d1aade825cdf447695f3fcc0f219ede7bae8613',

      novelId: '5d1aade825cdf447695f3fcc0f219ede7bae8613',
    },
    {
      title:
        'Yakshini l यक्षिणी। Author- Anand Usha Borkar',
      novelImgLink:
        'https://djhonz7dexnot.cloudfront.net/d0fd0dd3ccf00a20e362d2f3ce0d01393fa83e3f.webp',
      novelLink:
        'https://www.pocketnovel.com/novel/9e1d6d8ab592a14b0574103075a5ce95c5bfed43',

      novelId: '9e1d6d8ab592a14b0574103075a5ce95c5bfed43',
    },
    {
      title: 'The Mystery Of My Love | दी मिस्ट्री ऑफ़ माय लव | Author - Sabreen F.s',
      novelImgLink:
        'https://djhonz7dexnot.cloudfront.net/859d36c08c3afd1f3aafe8913e2cfe92116c82ae.jpeg',
      novelLink:
        'https://www.pocketnovel.com/novel/09cd07ebd806431c73ea9832b66b01c102f35d7d',
      novelId: '09cd07ebd806431c73ea9832b66b01c102f35d7d',
    },
    {
      title:
        'Revenge Of The God | रिवेंज ऑफ़ गॉड | Author - R.K',
      novelImgLink:
        'https://djhonz7dexnot.cloudfront.net/a852b41fef39c9e7ea67d546fa483a1803c0feb1.jpeg',
      novelLink:
        'https://www.pocketnovel.com/novel/255e8d1977c5e06c9b18a517c35fb0c0764a6d31',
      novelId: '255e8d1977c5e06c9b18a517c35fb0c0764a6d31',
    },
  ],
  storyPoints: [
    {
      key: 1,
      point:
        'सबसे अहम मुद्दा - उपन्यास के हर Chapter के अंत में दिलचस्प सवाल, या कोई इंट्रेस्टिंग डायलॉग हो, जिससे पाठकों की रूचि बनी रहे।',
    },
    {
      key: 2,
      point:
        'वर्णन (Narration ) भूतकाल (Past ) में हो और 100 शब्दों से ज्यादा का हो इस बात का ध्यान रखें ।',
    },
    {
      key: 3,
      point: (
        <>
          डायलाॅग नरेटिव्ह फॉरमॅट में हो, ना की ड्रॅमॅटिक फाॅरमॅट में जैसे की,
          <br />
          a. आर्य- में हुं सृष्टी का संरक्षक, विज्ञान का समिकरण!
          <br />
          b. समय से परे एक ऐसा योद्धा जिसने लोगो पर आने वाली विपत्तियों को दुर किया, “अर्जुन हे वो! सुपर अर्जुन जो दुष्टो का विनाषक है ! वो ही है आज का सुपर अर्जुन!”
        </>
      ),
    },
    {
      key: 4,
      point: (
        <>
          उपन्यास में दो संघर्ष (Conflict) होने चाहिए
          <br /> a. मुख्य संघर्ष  - जिसपे आपकी उपन्यास का पूरा a plot निर्भर हो !
          <br /> b.उप संघर्ष  - जिससे कहानी में रोमांच बरकरार रहे, और आपकी उपन्यास का Emotional graph.
          (भावनिक उतार- चढ़ाव) सही तरीके से प्रदर्शित होता रहे ।
        </>
      ),
    },
    {
      key: 5,
      point: 'उपन्यास लिखते वक़्त Punctuation का ध्यान रखें ।',
    },
  ],
}

export {
  campusDiariesHindi,
  campusDiaries,
  campusDiariesTamil,
  campusDiariesUniversalHindi
}